export default "/apps/maps/img/geocoder.png";